import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FaHospitalUser } from "react-icons/fa";
import { Buttton } from "../../../components";
import { Auth } from "../../../commonPage";
import { Commons } from "../../../utilities";
import { useAlert, useModal } from "../../../contexts";
import { actionCommon } from "../../../redux/actions";

const RegisterPage = () => {
    const patient_access = JSON.parse(localStorage.getItem("patient_access"));
    const isPatientLoggedIn = patient_access?.token;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { showAlert } = useAlert();
    const { showModal, hideModal } = useModal();

    useEffect(() => {
        if (isPatientLoggedIn) {
            navigate("/");
        }
    }, [isPatientLoggedIn, navigate]);

    const registerSubmit = (credentials) => {
        dispatch(
            actionCommon.registerUser(
                credentials,
                (error, response) => {

                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.error && error.data.error.ValidationErrors) {
                                    error.data.error.ValidationErrors.forEach((validationError) => {
                                        console.error(`${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message}`);
                                        showAlert("danger", validationError.Message, `${t("Error")} : ${validationError.Field}`);
                                    });
                                } else {
                                    showAlert("danger", `${t("Invalid_credentials")}`, `${t("Error")} !`);
                                }
                            } else {
                                showAlert("danger",
                                    `${t("unexpected_error")}`
                                        `${t("Error")} !`);
                            }
                        }
                    } else if (response) {
                        if (response.status === 200) {
                            showModal({
                                title: (
                                    <div className="message-modal-title-blk">
                                        <FaHospitalUser />
                                        <p className="exado-title-four">{t("success")}</p>
                                    </div>
                                ),
                                bodyContent: <p>{t("signUpPage.success_message")} </p>,
                                autoClose: 5000,
                                footer: (
                                    <Buttton.Buttton
                                        children={t("okay")}
                                        className="btn-solid-Aqua_Teal"
                                        onClick={hideModal}
                                    />
                                ),
                                className: "message-modal",
                            });
                            navigate("/patient/verify-otp", {
                                state: {
                                    email: credentials.email,
                                    userId: response.data.result.userId,
                                    UserType: credentials.UserType,
                                },
                            });
                        }
                    }
                }
            )
        );
    };

    if (isPatientLoggedIn) {
        return null;
    }

    return (
        <Auth.RegisterCommonPage
            userType={Commons.userType.patient}
            registerSubmit={registerSubmit}
            closeNavigate="/"
            loginPage="/patient/login"
        />
    );
};

export default RegisterPage;
